const resourceTPaths = {
  RESOURCE: "",
  SEARCH_RESOURCE: "search",
  RESOURCE_ID: (resourceId) => resourceId,
  RESOURCE_MAPPING: "mapping",
  RESOURCE_STATUS_GRAPH: (venueId) => `status-history/graph/venue/${venueId}`,
  RESOURCE_STATUS_KPI: (venueId) => `status-history/kpi/venue/${venueId}`,
  RESOURCE_STATUS_TIMELINE: (resourceId) => `${resourceId}/status-history/timeline`,
};

export default resourceTPaths;